import axios from "axios";
import { ApiKey, BaseUrl } from "../global";

export const getCNs = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Loadsheet/GetCNs', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const getDarazCNs = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Loadsheet/GetDarazCNs', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const getRiders = async (ids) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Loadsheet/GetRiders', ids, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

//GenerateLoadsheet

export const generateLoadsheet = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Loadsheet/GenerateLoadsheet', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const generateDarazLoadsheet = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Loadsheet/GenerateDarazLoadsheet', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}


export const getLoadsheets = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Loadsheet/GetLoadsheets', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const getLoadsheetCNs = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Loadsheet/GetLoadsheetCNs', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const checkExistingCNs = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Loadsheet/CheckExistingCNs', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}
